import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { FaEdit, FaTrash } from 'react-icons/fa';
import config from "../../../config/config";
import { getAuthToken } from "../../../utils/token";
import axios from "axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from '../../loader/Loader';
const customStyles = {
  headCells: {
    style: {
      backgroundColor: '#0d6efd',
      color: 'white',
      fontWeight: 'bold',
      fontSize: '14px',
    },
  },
};

export default function Material() {
  const [dataList, setDataList] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [listLoading, setListLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [backendErrors, setBackendErrors] = useState({});
  const initialState = {
    material_name: "",
    material_code: "",
    material_type: "",
    description: "",
    unit_price: "",
    quantity_in_stock: "",
    unit_of_measurement: "",
    is_active: true
  };
  const [units, setUnits] = useState([]);
  useEffect(() => {
    fetchUnits();
  }, []);
  const [form, setForm] = useState(initialState);

  useEffect(() => {
    fetchList();
  }, []);
  const fetchUnits = async () => {
    try {
      const res = await axios.post(`${config.API}/getUnit`, {}, {
        headers: {
          Authorization: `Bearer ${getAuthToken()}`,
        },
      });
      setUnits(res.data);
    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };
  const fetchList = async () => {
    const token = getAuthToken();
    if (!token) return;
    setListLoading(true);
    try {
      const res = await axios.get(`${config.API}/material/master/list`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setDataList(res.data.materials || []);
    } catch (err) {
      console.error("Error fetching material list:", err);
      toast.error("Failed to load data");
    } finally {
      setListLoading(false);
    }
  };

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const openAddModal = () => {
    setForm(initialState);
    setIsEditing(false);
    setEditingId(null);
    setShowModal(true);
  };

  const openEditModal = (item) => {
    setForm({ ...item });
    setIsEditing(true);
    setEditingId(item.id);
    setShowModal(true);
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication missing");
      return;
    }

    const payload = {
      material_name: form.material_name,
      material_code: form.material_code,
      material_type: form.material_type,
      description: form.description,
      unit_price: Number(form.unit_price),
      quantity_in_stock: Number(form.quantity_in_stock),
      unit_of_measurement: form.unit_of_measurement,
      is_active: Boolean(form.is_active),
    };

    setFormLoading(true);

    try {
      let response;

      if (isEditing && editingId) {
        response = await axios.put(
          `${config.API}/material/master/${editingId}`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } else {
        response = await axios.post(
          `${config.API}/material/master`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }
      if (response?.data?.errors) {
        setBackendErrors(response.data.errors);
        return;
      }

      // SUCCESS
      toast.success(response?.data?.message);
      setShowModal(false);
      fetchList();

    } catch (err) {
      const validationErrors = err?.response?.data?.errors;

      if (validationErrors) {
        setBackendErrors(validationErrors);
        return;
      }
    }
    finally {
      setFormLoading(false);
    }
  };


  const filtered = dataList.filter(item =>
    Object.values(item).join(' ').toLowerCase().includes(filterText.toLowerCase())
  );

  const columns = [
    { name: 'ID', selector: row => row.id, sortable: true },
    { name: 'Material Name', selector: row => row.material_name, sortable: true },
    { name: 'Code', selector: row => row.material_code, sortable: true },
    { name: 'Type', selector: row => row.material_type, sortable: true },
    { name: 'Description', selector: row => row.description, sortable: true },
    { name: 'Unit Price', selector: row => row.unit_price, sortable: true },
    { name: 'Qty in Stock', selector: row => row.quantity_in_stock, sortable: true },
    { name: 'Unit', selector: row => row.unit_of_measurement, sortable: true },
    { name: 'Active', selector: row => row.is_active ? 'Yes' : 'No', sortable: true },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex gap-2">
          <button className="btn btn-sm btn-primary" onClick={() => openEditModal(row)}><FaEdit /></button>
          <button className="btn btn-sm btn-danger"><FaTrash /></button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
  ];

  return (
    <div className="container mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <strong className="mb-0 fs-4">Material Master</strong>
        <div>
          <input
            type="text"
            className="form-control d-inline-block me-2"
            placeholder="Search..."
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
            style={{ width: '200px' }}
          />
          <button className="btn btn-primary" onClick={openAddModal}>+ Add Material</button>
        </div>
      </div>

      {listLoading ? (
        <div className="text-center"><Loader /></div>
      ) : (
        <DataTable
          columns={columns}
          data={filtered}
          pagination
          highlightOnHover
          customStyles={customStyles}
        />
      )}

      {showModal && (
        <div className="modal d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-primary text-light">
                <h5>{isEditing ? 'Edit Material' : 'Add Material'}</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                  onClick={() => setShowModal(false)}
                />
              </div>
              <div className="modal-body">
                <div className="row g-3">

                  {/* Material Name */}
                  <div className="col-md-4">
                    <label className="form-label">Material Name</label>
                    <input
                      type="text"
                      name="material_name"
                      className="form-control"
                      value={form.material_name}
                      onChange={handleInput}
                      disabled={formLoading}
                    />
                    {backendErrors?.material_name && (
                      <div className="text-danger small mt-1">
                        {backendErrors.material_name[0]}
                      </div>
                    )}
                  </div>

                  {/* Material Code */}
                  <div className="col-md-4">
                    <label className="form-label">Material Code</label>
                    <input
                      type="text"
                      name="material_code"
                      className="form-control"
                      value={form.material_code}
                      onChange={handleInput}
                      disabled={formLoading}
                    />
                    {backendErrors.material_code && (
                      <div className="text-danger small mt-1">{backendErrors.material_code[0]}</div>
                    )}
                  </div>

                  {/* Material Type */}
                  <div className="col-md-4">
                    <label className="form-label">Material Type</label>
                    <input
                      type="text"
                      name="material_type"
                      className="form-control"
                      value={form.material_type}
                      onChange={handleInput}
                      disabled={formLoading}
                    />
                  </div>

                  {/* Description */}
                  <div className="col-md-4">
                    <label className="form-label">Description</label>
                    <input
                      type="text"
                      name="description"
                      className="form-control"
                      value={form.description}
                      onChange={handleInput}
                      disabled={formLoading}
                    />
                  </div>

                  {/* Unit Price */}
                  <div className="col-md-4">
                    <label className="form-label">Unit Price</label>
                    <input
                      type="number"
                      name="unit_price"
                      className="form-control"
                      value={form.unit_price}
                      onChange={handleInput}
                      disabled={formLoading}
                    />
                  </div>

                  {/* Quantity in Stock */}
                  <div className="col-md-4">
                    <label className="form-label">Quantity in Stock</label>
                    <input
                      type="number"
                      name="quantity_in_stock"
                      className="form-control"
                      value={form.quantity_in_stock}
                      onChange={handleInput}
                      disabled={formLoading}
                    />
                  </div>

                  {/* Unit of Measurement */}
                  <div className="row">
                    <div className="col-md-4">
                      <label className="form-label">Unit of Measurement</label>

                      <select
                        name="unit_of_measurement"
                        className="form-select"
                        value={form.unit_of_measurement}
                        onChange={handleInput}
                        disabled={formLoading}
                      >
                        <option value="">Select Unit</option>

                        {units.map((unit) => (
                          <option key={unit.id} value={unit.name}>
                            {unit.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  {/* Active Checkbox */}
                  <div className="col-md-4 d-flex align-items-center">
                    <input
                      type="checkbox"
                      name="is_active"
                      checked={form.is_active}
                      onChange={handleInput}
                      disabled={formLoading}
                      className="form-check-input me-2"
                    />
                    <label className="form-check-label">Active</label>
                  </div>

                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)} disabled={formLoading}>Cancel</button>
                <button className="btn btn-primary" onClick={handleSubmit} disabled={formLoading}>
                  {formLoading ? 'Saving...' : isEditing ? 'Update' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
